export default __webpack_public_path__ + "static/media/trash_icon.47deea20.svg";